'use strict';

/**
 * Cart Component for Margiela Revamp
 */

const cartSheetId = 'cart-sheet';
const selectedColorClass = 'selected-color';
const selectedSizeClass = 'selected-size';
const checkoutBtnClass = 'js-checkout-btn';
const hideClass = 'd-none';
const SELECTORS = {
  // Cart
  cartSheet: '#'+cartSheetId,
  cartContainer: '.cart-container',
  itemNumber: '.js-cart-item-number',
  // Product
  productWrapper: '.js-lineitem',
  imageValue: '.js-image-value',
  colorValue: '.js-color-value',
  sizeValue: '.js-size-value',
  quantityValue: '.js-quantity-value',
  dddWrap: '.product-row__body_ddd-item',
  dddValue: '.product-row__body_ddd-item-value',
  priceWripper: '.js-price',
  removeProductBtn: '.js-remove-cta',
  editProductBtn: '.js-edit-cart-product',
  // Totals 
  grandTotal: '.js-grandTotal',
  // Checkout
  checkoutBtn: '.'+checkoutBtnClass,
  fastCheckoutUrl: '.track-fast-checkout-url',
  removeFastCheckoutUrl: '.remove-track-fast-checkout-url',
  applepayBtn: '.apple-pay-button',
  paypalBtn: '.paypal-cart-button',
  paypalInitContainer: '#cart-paypal-button-container',
  paypalSandbox: 'paypal-checkout-sandbox',
  // Edit Section
  editSheet: '.edit-cart_container',
  colorVariant: '.js-color-option-cart',
  selectedColor: '.'+selectedColorClass,
  selectedColorText: '.js-color-selected',
  sizeContainer: '.js-size-container',
  sizeSwitcher: '.size-system-selector',
  sizeVariant: '.js-size-option-cart',
  selectedSize: '.'+selectedSizeClass,
  selectedSizeText: '.js-size-selected',
  qntProductInput: '.js_quantity_product',
  qntProductText: '.js-qnt-value',
  qntCTA: '.js-qnt-edit',
  addWishlistBtn: '.js_add-to-wish-list',
  updateCTA: '.js-update-cart-btn',
  // Errors
  cartError: '.js-cart-error',
  editError: '.js-edit-error',
  productError: '.js-product-error'
};
const cart = document.querySelector(SELECTORS.cartContainer);
const editSheet = document.querySelector(SELECTORS.editSheet);
const isCartSheet = cart && !!cart.closest(SELECTORS.cartSheet);
let debouncerTimeout = null;

// SECTION UTILITY 

function loadScript(url) {
  // clean existing paypal script
  let existingScripts = document.querySelectorAll('script[src="' + url + '"]');
  existingScripts.forEach(script => script.remove());
  // clean existing paypal button
  document.querySelectorAll(SELECTORS.paypalBtn).forEach((button) => button.innerHTML = '');
  // reload paypal script that will initialize paypal button
  let script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
}

function showCartError(message) {
  let errorDiv = cart.querySelector(SELECTORS.cartError);
  errorDiv.textContent = message || errorDiv.dataset.error;
  errorDiv.classList.remove(hideClass);
}
function hideCartError() {
  document.querySelector(SELECTORS.cartError).classList.add(hideClass);
}

function showEditCartError(message) {
  let errorDiv = editSheet.querySelector(SELECTORS.editError);
  errorDiv.textContent = message || errorDiv.dataset.error;
  errorDiv.classList.remove(hideClass);
}
function hideEditCartError() {
  editSheet.querySelector(SELECTORS.editError).classList.add(hideClass);
}

function debounce(func) {   
  clearTimeout(debouncerTimeout);
  debouncerTimeout = setTimeout(() => {
    func.apply();
  }, 200);
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
*/
function findItem(array, match) {
  for (let i = 0, l = array.length; i < l; i++) {
    if (match.call(this, array[i])) {
      return array[i];
    }
  }
  return null;
}

/**
 * Formats a date string into 'EEE MMM d' equivalent 
 * @param {string} dateString - The date string to format
 * @returns {string} - The formatted date string
 */
function formatEDD(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  
  const locale = document.documentElement.lang || 'en-US';
  const weekday = date.toLocaleDateString(locale, { weekday: 'short' });
  const month = date.toLocaleDateString(locale, { month: 'short' });
  const day = date.getDate();
  
  return `${weekday} ${month} ${day}`;
}

// SECTION HANDLER 

/*
  Listen to express payment CTA
*/
function handleExpressListener() {

  // paypal - based on observer for paypal sandbox element
  const observer = new MutationObserver(function(mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.classList && node.classList.contains(SELECTORS.paypalSandbox)) {
              fastCheckout('paypal');
            } else if (node.querySelector) {
              const sandboxNode = node.querySelector('.' + SELECTORS.paypalSandbox);
              if (sandboxNode) {
                fastCheckout('paypal');
              }
            }
          }
        });
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // applepay - based on apple pay click
  document.body.addEventListener('click', function(e) {
    if (e.target && e.target.closest(SELECTORS.applepayBtn)) {
      fastCheckout('applepay');
    }
  });

  // remove fast checkout if "checkout cta" is clicked
  document.body.addEventListener('click', function(e) {
    if (e.target && e.target.classList.contains(checkoutBtnClass)) {
      removeFastCheckout();
    }
  });

}

/*
  Listen to cart:updateCartBadge event, in order to update the cart badge in the header
  The event will be dispatched on document element

  EXAMPLE: 
  document.dispatchEvent(new CustomEvent('cart:updateCartBadge', {
    detail: { itemsCount: 3 }
  }));
*/
function handleUpdatCartBadge() {
  document.addEventListener('cart:updateCartBadge', (event) => {
    let itemsCount = 0;
    if( event && event.detail && event.detail.itemsCount ) {
      itemsCount = event.detail.itemsCount;
    }

    const basketBadges = document.querySelectorAll('.js-basket-badge');
    basketBadges.forEach(badge => {
      // when there are 0 items in cart, show nothing on the basket badge
      badge.textContent = itemsCount === 0 ? '' : itemsCount;
    });

    const cartBadges = document.querySelectorAll('.js-cart-badge');
    cartBadges.forEach(badge => {
      badge.textContent = itemsCount || '0';
    });
  });
}

/* 
  Attach the event handler on the Edit Cart Back CTA button in the Edit Cart sheet
*/
function handleEditCartBackCTA() {
  let backToCart = document.querySelectorAll('.js-back-to-cart');
  backToCart.forEach(el => el.addEventListener('click', () => {
    // Emit MMSheet:switchContent event to show main cart content 
    document.dispatchEvent(
      new CustomEvent('MMSheet:initialContent', { detail: { id: 'cart-sheet' }})
    );
    
    // Emit MMPopup:close event to eventually close "add-to-wishlist" popup
    document.dispatchEvent(
      new CustomEvent('MMPopup:close', {
        detail: {
          id: 'add-to-wishlist-popup-' + window.brandCategory.toLowerCase()
        }
      }
    ));
  }));
}

/*
  Listen to cart:refreshCart in order to update the cart content
  The event will be dispatched on document element

  EXAMPLE: 
  document.dispatchEvent(new CustomEvent('cart:refreshCart'));
*/
function handleRefreshCart() {
  const refreshCartUrl = cart ? cart.dataset.remoteContent : null;

  document.addEventListener('cart:refreshCart', (event) => {
    hideCartError();
    fetch(refreshCartUrl)
      .then((response) => {
        if (!response.ok) {
          showCartError();
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then((responseData) => {
        if (responseData && !responseData.error) {
          
          // refresh rendered cart content
          cart.innerHTML = responseData;

          if(event.detail && event.detail.callback) {
            event.detail.callback();
          }

          let itemNumber = cart.querySelector(SELECTORS.itemNumber);
          if(itemNumber) {
            // Emit cart:updateCartBadge event to update the cart badge
            document.dispatchEvent(new CustomEvent('cart:updateCartBadge', {
              detail: { itemsCount: parseInt(itemNumber.value) }
            }));
          }

          handleCartFunctionality();

          // if the "edit section" was shown --> return to main cart section
          document.dispatchEvent(
            new CustomEvent('MMSheet:initialContent', { detail: { id: 'cart-sheet' }})
          );
        } else {
          showCartError();
        }
      })
      .catch(() => {
        showCartError();
      });
  });
}

/*
  Listen to cart:openCart event, in order to refresh and open the cart sheet.
  The event will be dispatched on document element

  EXAMPLE: 
  document.dispatchEvent(new CustomEvent('cart:openCart'));
*/
function handleOpenCart() {
  document.addEventListener('cart:openCart', (event) => {
    const basketBadges = document.querySelectorAll('.js-basket-badge');
    if (basketBadges && basketBadges.length > 0) {
      const cartBadges = document.querySelectorAll('.js-cart-badge');
      cartBadges.forEach(badge => {
        badge.textContent = basketBadges[0].textContent.trim() || '0';
      });
    }

    document.dispatchEvent(new CustomEvent('cart:refreshCart', {
      detail: {
        callback: () => {
          document.dispatchEvent(new CustomEvent('MMSheet:open', { 
            detail: { id: cartSheetId }
          })); 
          // Tealium event: minicart opened
          $('body').trigger('cart:minicartOpen');
        }
      }
    })); 
   
  })
}

/*
  Active Cart Functionality 
  Used after refresh sheet cart and after loding cart page
*/
function handleCartFunctionality() {
  // add listener to every edit button
  let editBtns = cart.querySelectorAll(SELECTORS.editProductBtn);
  editBtns.forEach((btn) => {
    btn.addEventListener('click', () => { populateEditModal(btn); });
  });

  // manage paypal express initialization
  let paypalInitContainer = document.querySelector(SELECTORS.paypalInitContainer);
  if(paypalInitContainer) {
    let prepandPaypalminicart = paypalInitContainer.dataset.prepandpaypalminicart;

    fetch(prepandPaypalminicart, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json, text/javascript, */*; q=0.01'
      }
    })
      .then((res) => {
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('json')) {
          return res.json();
        }
        return res.text();
      })
      .then((responseData) => {
        if (responseData && !responseData.error) {
          let scriptUrl = document.querySelector(SELECTORS.paypalInitContainer).dataset.scripturl;
          loadScript(scriptUrl);
        }
      })
      .catch((error) => console.error(error));
  }
}

/*
  Listen to click on quantity update buttons inside edit cart section
  Update quantity in the input and in the text field, 
  only if the new quantity is in the range [minQnt, maxQnt]
*/
function handleQuantityUpdateListener() {
  const qntProductInput = document.querySelector(SELECTORS.qntProductInput);
  const qntProductText = document.querySelector(SELECTORS.qntProductText);
  const minQnt = qntProductInput.dataset.min;
  const maxQnt = qntProductInput.dataset.max;
  
  let qntEditBtns = editSheet.querySelectorAll(SELECTORS.qntCTA);
  qntEditBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      let unit = parseInt(btn.dataset.unit);
      let currentQnt = parseInt(qntProductInput.value);
      let newQnt = currentQnt + unit;
      if (newQnt >= minQnt && newQnt <= maxQnt) {
        qntProductInput.value = newQnt;
        qntProductText.textContent = newQnt;
        editSheet.querySelectorAll(SELECTORS.colorVariant).forEach(element => {
          let currentUrl = element.dataset.url;
          if(currentUrl.indexOf('&quantity') > -1) {
            element.dataset.url = currentUrl.replace('quantity=' + currentQnt, 'quantity=' + newQnt);
          }
        });
        editSheet.querySelectorAll(SELECTORS.sizeVariant).forEach(element => {
          let currentUrl = element.dataset.url;
          if(currentUrl.indexOf('&quantity') > -1) {
            element.dataset.url = currentUrl.replace('quantity=' + currentQnt, 'quantity=' + newQnt);
          }
        });
        const productUrl = editSheet.querySelector(SELECTORS.selectedSize).dataset.url;
        // retrive information for selected variant and quantity
        debounce(() => {
          fetch(productUrl, {
            method: 'GET',
            headers: { 'Accept': 'application/json' }
          })
          .then(response => {
            if (!response.ok) {
              showEditCartError();
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then(data => {
            // enable or disable update button depending on product availability
            if(!data.product.available){
              editSheet.querySelector(SELECTORS.updateCTA).disabled = true;
            } else {
              editSheet.querySelector(SELECTORS.updateCTA).disabled = false;
            }
          })
          .catch(err => {
            if (err && err.redirectUrl) {
              window.location.href = err.redirectUrl;
            } else if (err && err.errorMessage) {
              showEditCartError(err.errorMessage);
            } else {
              console.error(err);
            }
          });
        });
      }
    });
  });

}

/*
  Listen to click on color variation buttons inside edit cart section
  Update size elements in accordion
*/
function handleColorChangeListener() {
  
  let colorOptions = editSheet.querySelectorAll(SELECTORS.colorVariant);
  colorOptions.forEach((option) => {
    option.addEventListener('click', (e) => {
      hideEditCartError();
      const colorSelectedBtn = e.target;
      if(!colorSelectedBtn.classList.contains(selectedColorClass)) {
        const colorPidUrl = colorSelectedBtn.dataset.url;
        if (colorPidUrl) {

          // edit color info to be immediatly change
          editSheet.querySelector(SELECTORS.selectedColorText).textContent = colorSelectedBtn.dataset.displayValue;
          editSheet.querySelectorAll(SELECTORS.selectedColor).forEach(element => {
            element.classList.remove(selectedColorClass);
          });
          colorSelectedBtn.classList.add(selectedColorClass);
          colorSelectedBtn.nextElementSibling.classList.add(selectedColorClass);

          // retrive information for selected variant
          debounce(() => {
            fetch(colorPidUrl, {
              method: 'GET',
              headers: { 'Accept': 'application/json' }
            })
            .then(response => {
              if (!response.ok) {
                showEditCartError();
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(data => {
              // update product information for the future actions in edit modal
              editSheet.dataset.updatedPid = data.product.id;
              editSheet.dataset.clickedImage = data.product.swipeableImages.large[0].url;
            
              // update size elemens in size selection grid
              const sizeContainer = editSheet.querySelector(SELECTORS.sizeContainer);
              sizeContainer.querySelectorAll(SELECTORS.sizeVariant).forEach(element => element.parentElement.remove());
              for (let i = 0; i < data.product.variationAttributes.length; i++) {
                if (data.product.variationAttributes[i].attributeId == 'size') {
                  for (let a = 0; a < data.product.variationAttributes[i].values.length; a++) {
                    let sizeElement = createSizeElement(data.product.variationAttributes[i].values[a]);
                    sizeContainer.insertAdjacentHTML('beforeend', sizeElement);
                  }
                }
              }
              handleSizeChangeListener();

              // enable or disable update button depending on product availability
              if(!data.product.available){
                editSheet.querySelector(SELECTORS.updateCTA).disabled = true;
              } else {
                editSheet.querySelector(SELECTORS.updateCTA).disabled = false;
              }

            })
            .catch(err => {
              if (err && err.redirectUrl) {
                window.location.href = err.redirectUrl;
              } else if (err && err.errorMessage) {
                showEditCartError(err.errorMessage);
              } else {
                console.error(err);
              }
            });
          });
        }
      }
    });
  });

}

/*
  Listen to click on size variation buttons inside edit cart section
*/
function handleSizeChangeListener() {

  const sizeSwitcher = editSheet.querySelector(SELECTORS.sizeSwitcher);
  let sizeOptions = editSheet.querySelectorAll(SELECTORS.sizeVariant);
  sizeOptions.forEach((option) => {
    option.addEventListener('click', (e) => {
      hideEditCartError();
      const sizeSelectedBtn = e.target;
      if(!sizeSelectedBtn.classList.contains(selectedSizeClass)) {
        const sizePidUrl = sizeSelectedBtn.dataset.url;
        if (sizePidUrl) {

          // edit size info to be immediatly change
          // swatch text already follows the size system in use (default one set server side)
          var sizeSwatchValue = sizeSelectedBtn.parentElement.querySelector('.mm-size-swatch__value');
          var sizeText = sizeSwatchValue ? sizeSwatchValue.textContent.trim() : sizeSelectedBtn.dataset.displayValue;
          // The switcher markup is rendered whenever the site preference is on, but the composite
          // label must follow the locale guarded flag (no "IT 36 [IT 36]" on IT locales).
          if (!!sizeSwitcher && sizeSwitcher.dataset.sizeSwitcherEnabled === 'true') {
            let country = sizeSwitcher.dataset.country;
            let isMM6 = sizeSwitcher.dataset.sizeBrand === 'mm6';
            sizeText = 'IT ' + sizeSelectedBtn.value + ' ' + (isMM6 ? '(' : '[') + country + ' ' + sizeSelectedBtn.dataset.displayValue + (isMM6 ? ')' : ']');
          }
          editSheet.querySelector(SELECTORS.selectedSizeText).textContent = sizeText;
          editSheet.querySelectorAll(SELECTORS.selectedSize).forEach(element => {
            element.classList.remove(selectedSizeClass);
          });
          sizeSelectedBtn.classList.add(selectedSizeClass);

          // retrive information for selected variant
          debounce(() => {
            fetch(sizePidUrl, {
              method: 'GET',
              headers: { 'Accept': 'application/json' }
            })
            .then(response => {
              if (!response.ok) {
                showEditCartError();
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(data => {
              // update product information for the future actions in edit modal
              editSheet.dataset.updatedPid = data.product.id;
              editSheet.dataset.clickedImage = data.product.swipeableImages.large[0].url;

              // update url for color elements
              for (let i = 0; i < data.product.variationAttributes.length; i++) {
                if (data.product.variationAttributes[i].attributeId == 'color') {
                  for (let a = 0; a < data.product.variationAttributes[i].values.length; a++) {
                    let color = data.product.variationAttributes[i].values[a];
                    editSheet.querySelector(SELECTORS.colorVariant + '.value-' + color.id).dataset.url = color.url;
                  }
                }
              }

              // enable or disable update button depending on product availability
              if(!data.product.available){
                editSheet.querySelector(SELECTORS.updateCTA).disabled = true;
              } else {
                editSheet.querySelector(SELECTORS.updateCTA).disabled = false;
              }

            })
            .catch(err => {
              if (err && err.redirectUrl) {
                window.location.href = err.redirectUrl;
              } else if (err && err.errorMessage) {
                showEditCartError(err.errorMessage);
              } else {
                console.error(err);
              }
            });
          });
        }
      }
    });
  });

}

/*
  Listen to switch on size locale inside edit cart section
*/
function handleSizeSwitcherListener() {
  const sizeSwitcher = editSheet.querySelector(SELECTORS.sizeSwitcher)
  let sizeSwitches = sizeSwitcher.querySelectorAll('input[type=radio]');
  sizeSwitches.forEach(switchBtn => {
    switchBtn.addEventListener('change', (e) => {
      var selectedSystem = e.target.value;

      editSheet.querySelectorAll(SELECTORS.sizeVariant).forEach(element => {
        var displayValue = element.dataset.displayValue;
        var value = element.value;
        var span = element.parentElement.querySelector('.mm-size-swatch__value');
        if (span) {
          if (selectedSystem === 'LABEL') {
            span.textContent = value;
          } else {
            span.textContent = displayValue;
          }
        }
      });
      
    });
  });
}

/* 
  Listen to click on update CTA inside edit cart section
*/
function handleUpdateListener() {
  const updateCTA = editSheet.querySelector(SELECTORS.updateCTA);
  updateCTA.addEventListener('click', (e) => {
    e.preventDefault();
    
    // retrive url and selected data to update
    const updateProductUrl = updateCTA.dataset.url;
    const pid = editSheet.dataset.updatedPid || editSheet.dataset.pid;
    const uuid = editSheet.dataset.uuid;
    const selectedQuantity = editSheet.querySelector(SELECTORS.qntProductInput).value;

    // create update form
    let formData = new FormData();
    if (uuid) formData.append('uuid', uuid);
    if (pid) formData.append('pid', pid);
    if (selectedQuantity) formData.append('quantity', selectedQuantity);
    
    if (updateProductUrl) {
      updateCTA.disabled = true;
      hideEditCartError();
      fetch(updateProductUrl, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(err => { throw err; });
        }
        updateCTA.disabled = false;
        return response.json();
      })
      .then(data => {
        if(data.cartModel) {
          // check on basket validity
          let isValid = checkBasketValidity(data.cartModel);
          if(isValid) {
            //update edited product details
            updateProductDetails(data, uuid);
            // update cart rows
            updateCartRows(data.cartModel);
            // Emit cart:updateCartBadge to update cart badge across the page
            document.dispatchEvent(new CustomEvent('cart:updateCartBadge', {
              detail: { itemsCount: data.cartModel.numItems }
            }));
          }

          if (data.uuidToBeDeleted) {
            let elToRemove = cart.querySelector(SELECTORS.productWrapper+'[data-uuid="'+ data.uuidToBeDeleted+ '"]');
            if (elToRemove) {
              elToRemove.remove();
            }
          }
        }
    
        if(isCartSheet) {
          // Emit MMSheet:switchContent event to show main cart content 
          document.dispatchEvent(
            new CustomEvent('MMSheet:initialContent', { detail: { id: 'cart-sheet' }})
          );
        }
        else {
          // Emit MMSheet:close event to close edit cart sheet
          document.dispatchEvent(
            new CustomEvent('MMSheet:close', { detail: { id: 'edit-cart-sheet' }})
          );
        }

        // Emit analitycs and generic events
        document.body.dispatchEvent(new CustomEvent('cart:update'));
        $('body').trigger('cart:productModified', data);
      })
      .catch(err => {
        console.log(err);
        if (err && err.redirectUrl) {
          window.location.href = err.redirectUrl;
        } else {
          updateCTA.disabled = false;
          showEditCartError((err && err.errorMessage) ? err.errorMessage : null);
        }
      });
    
    }
  });
}

/*
 Call the single handler for each update listener 
*/
function handleEditProductListeners() {
  handleQuantityUpdateListener();
  handleColorChangeListener();
  handleSizeChangeListener();
  if(!!editSheet.querySelector(SELECTORS.sizeSwitcher)) {
    handleSizeSwitcherListener();
  }
  handleUpdateListener();
}

// OPERATIONAL FUNCTION

/*
  Retrive information from product to be edited and replace it in the Edit Cart sheet
*/
async function populateEditModal(editButton) {
  let pid = editButton.dataset.pid;
  let masterPid = editButton.dataset.masterPid;
  let uuid = editButton.dataset.uuid;
  let productDiv = editButton.closest(SELECTORS.productWrapper);
  let url = editButton.dataset.href+'?uuid='+uuid+'&pid='+pid+'&pageBrand='+window.brandCategory;
  // set edit sheet info
  editSheet.dataset.pid = pid;
  editSheet.dataset.masterPid = masterPid;
  editSheet.dataset.uuid = uuid;
  editSheet.innerHTML = '';
  
  // reset error
  hideCartError();
  productDiv.querySelector(SELECTORS.productError).classList.add(hideClass);

  if(!isCartSheet) {
    // Emit MMSheet:open event to open edit sheet
    document.dispatchEvent(
      new CustomEvent('MMSheet:open', { detail: { id: 'edit-cart-sheet' }})
    );
  }
  
  fetch(url)
    .then((response) => {
      if (!response.ok) {
        showCartError();
        throw new Error(`HTTP error: ${response.status}`);
      }
      return response.json();
    })
    .then((json) => {

      if(json.error) {
        productDiv.querySelector(SELECTORS.productError).textContent = json.errorMessage;
        productDiv.querySelector(SELECTORS.productError).classList.remove(hideClass);
        return;
      }
      
      // Tealium event "Modify Prodcut Popup Open"
      $('body').trigger('cart:modifyProductOpen');

      // refresh rendered edit section content
      const domparser = new DOMParser();
      let quickView = domparser.parseFromString(json.renderedTemplate, 'text/html');
      editSheet.innerHTML = quickView.body.innerHTML;

      // handle product edit listners
      handleEditProductListeners();

      if(isCartSheet) {
        // Emit MMSheet:switchContent event to show edit section
        document.dispatchEvent(
          new CustomEvent('MMSheet:switchContent', { detail: { id: 'cart-sheet' }})
        );
      }

    }).catch((err) => {
      if (err.responseJSON && err.responseJSON.redirectUrl) {
        window.location.href = err.responseJSON.redirectUrl;
      } else {
        showCartError();
      }
    });
}

/*
  Create size element for the size selection grid.
  The grid is rebuilt on color change: keep the size system currently picked in the switcher.
*/
function createSizeElement(size) {
  const activeSystem = editSheet.querySelector(SELECTORS.sizeSwitcher + ' input[type=radio]:checked');
  const sizeText = activeSystem && activeSystem.value === 'LABEL' ? size.value : size.displayValue;
  return `<label class="col-6 mm-size-swatch ${!size.selectable ? 'not-available' : ''}">
    <input type="radio" hidden name="variation-size-element-cart" data-name="variant_${size.displayValue}"
      value="${size.value}" data-display-value="${size.displayValue}" ${size.selected ? 'checked' : ''}
      class="value-${size.id} mm-size-swatch__inner js-size-option-cart ${size.selected ? 'selected-size' : ''}"
      data-value-id="value-${size.id}" data-url="${size.url}" />
    <span class="inner-text">
      <span class="mm-size-swatch__name">
        <span class="icon icon--mm-symbol-circle-fill"></span>
        <span class="mm-size-swatch__value">${sizeText}</span>
        <span class="icon icon--mm-bell ${size.selectable ? hideClass : ''}"></span>
      </span>
    </span>
  </label>`;
}

/**
 * Update cart rows info and order totals
 * @param {Object} data - cart model from the server
*/
function updateCartRows(data) {
  // cart totals
  cart.querySelector(SELECTORS.grandTotal).textContent = data.totals.grandTotal;

  // row prices
  data.items.forEach(function (item) {
    if (item.priceTotal && item.priceTotal.renderedPrice) {
      let productWrap = cart.querySelector(SELECTORS.productWrapper+'[data-uuid="'+ item.UUID+'"]');
      if(productWrap) {
        productWrap.querySelector(SELECTORS.priceWripper).innerHTML = item.priceTotal.renderedPrice;
      }
    }
  });
 
}

/**
 * Update edited product details
 * @param {Object} data - AJAX data from the server
 * @param {string} uuid - edited product UUID
*/
function updateProductDetails(data, uuid) {
  const items = data.cartModel.items;
  let lineItem = findItem(items, function (item) {
    return item.UUID === uuid;
  });
  if(!lineItem) return;

  let productWrap = cart.querySelector(SELECTORS.productWrapper+'[data-uuid="'+ uuid+ '"]');
  if(!productWrap) return;

  // color and size
  if (lineItem.variationAttributes) {
    let colorAttr = findItem(lineItem.variationAttributes, function (attr) {
      return attr.attributeId === 'color';
    });
    if(colorAttr) {
      let colorElement = productWrap.querySelector(SELECTORS.colorValue);
      if(colorElement) {
        colorElement.textContent = colorAttr.displayValue;
      }
    }

    let sizeAttr = findItem(lineItem.variationAttributes, function (attr) {
      return attr.attributeId === 'size';
    });
    if(sizeAttr) {
      let sizeElement = productWrap.querySelector(SELECTORS.sizeValue);
      if(sizeElement) {
        // on-label (IT) size is the default view on some sites (e.g. US), flag rendered by cart-line-item.isml
        sizeElement.textContent = sizeElement.dataset.defaultSizeLabel === 'true' && sizeAttr.value ? sizeAttr.value : sizeAttr.displayValue;
      }
    }
  }

  // image
  let imageElement = productWrap.querySelector(SELECTORS.imageValue);
  if(imageElement) {
    imageElement.src = lineItem.images.small[0].url;
    imageElement.alt = lineItem.images.small[0].alt;
    imageElement.title = lineItem.images.small[0].title;
  }

  // quantity
  productWrap.querySelector(SELECTORS.quantityValue).textContent = lineItem.quantity;
 
  // ddd info
  let dddContainer = productWrap.querySelector(SELECTORS.dddWrap);
  if(dddContainer){
    dddContainer.classList.add(hideClass);
    if(data.cartDDDRequest && data.cartDDDRequest.itemEDD) {
      for (let i = 0; i < data.cartDDDRequest.itemEDD.length; i++) {
        let item = data.cartDDDRequest.itemEDD[i];
        let shippingMethodId = item.ShippingMethodId ? item.ShippingMethodId.toLowerCase() : '';
        if (item.itemId === data.newProductId && (shippingMethodId.includes('standard') || shippingMethodId.includes('ground'))) {
          dddContainer.querySelector(SELECTORS.dddValue).textContent = formatEDD(item.actualEDD);
          dddContainer.classList.remove(hideClass);
        }
      }
    }
  }

  // action cta
  productWrap.querySelector(SELECTORS.removeProductBtn).dataset.pid = lineItem.id;
  productWrap.querySelector(SELECTORS.editProductBtn).dataset.pid = lineItem.id;

}

/**
 * Checks whether the basket is valid
 * If invalid displays error message and disables checkout button
 * @param {Object} data - cart model response from the server
*/
function checkBasketValidity(data) {
  if (data.valid.error) {
    if (data.valid.message) {
      showCartError(data.valid.message);
    } else {
      document.dispatchEvent(new CustomEvent('cart:refreshCart'));
    }
    cart.querySelector(SELECTORS.checkoutBtn).disabled = true;
    return false;
  } 

  cart.querySelector(SELECTORS.checkoutBtn).disabled = false;
  return true;
}

/*
  Fast Checkout trigger
*/
function fastCheckout(cartType) {
  const buttonPosition = isCartSheet ? 'minicart' : 'shoppingbag';
  var fastCheckoutUrlItem = cart.querySelector(SELECTORS.fastCheckoutUrl);
  var fastCheckoutUrl = fastCheckoutUrlItem ? fastCheckoutUrlItem.value : null;
  var fastCheckoutData = cartType + '_fast_' + buttonPosition;

  if (fastCheckoutUrl) {
    var url = new URL(fastCheckoutUrl, window.location.origin);
    url.searchParams.append('fastPayment', fastCheckoutData);

    fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      $('body').trigger('checkout:fastCheckoutStart', [cartType, buttonPosition]);
    })
    .catch(err => {
      console.error('Fast checkout error:', err);
    });
  }
}

/*
  Fast Checkout Remove 
*/
function removeFastCheckout() {
  var removeFastCheckoutUrlItem = cart.querySelector(SELECTORS.removeFastCheckoutUrl);
  var removeFastCheckoutUrl = removeFastCheckoutUrlItem ? removeFastCheckoutUrlItem.value : null;
  if (removeFastCheckoutUrl) {
    fetch(removeFastCheckoutUrl, {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      removeFastCheckoutUrlItem.dataset.fastcheckout = false;
    })
    .catch(err => {
      console.error('Fast checkout error:', err);
    });
  }
 
}

module.exports = {
  init: function () {
    if(!cart)
      return;
    
    // tealium/tealiumEvents is NOT included here: main.js already does it, and this module is
    // reached through main.js -> common.js -> ./cart, so a second processInclude only re-bound
    // every handler (each Tealium event sent twice) and re-ran updateCartAndWishlist, doubling
    // the Cart-GetCart / Wishlist-GetWishlist calls on every page.
    handleUpdatCartBadge();
    if(isCartSheet) {
      handleRefreshCart();
      handleOpenCart();
      handleEditCartBackCTA();
    }
    else {
      handleCartFunctionality();
    }
    handleExpressListener();
  }
};